module.exports = __webpack_public_path__ + "img/group.01ec0692.png";